import React, { useEffect } from "react";
import label from "../../labels/postExaminationProcessObjective_en.json";

const DescriptiveMarksCalculation = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  return (
    <div className="dashboardContentArea">
      <h5> {label.DescriptiveMarksCalculation} </h5>
      <div className="row dashboardCards"></div>
    </div>
  );
};

export default DescriptiveMarksCalculation;
